var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{staticClass:"custom-image",attrs:{"image":require('@/assets/imgs/common/暂无数据@2x.png'),"description":_vm.description}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }